import {Outlet, Link} from 'react-router';

import { useScrollToTop } from '../hooks/useScrollToTop';
import Nav from './Nav';
import BuyMeACoffee from './BuyMeACoffee';
import Footer from './Footer';
import CookieBanner from './CookieBanner';

export default function Layout() {
    // ☠️ An SPA does not reset scroll on navigation; the browser only does that for a real
    // document load. Without this, a link followed from halfway down one page lands halfway
    // down the next. Hash links are exempt — see the hook.
    useScrollToTop();

    // ☠️ Four fetches stood here — `states`, `parties`, `periods`, `categories` — filling a
    // Redux store that only the previous implementation's pages ever read. They 404ed on
    // every page load of the rebuild, because the rebuild's API does not serve them.
    // ⚠️ `check:frontend` is structurally blind to this: it runs with no backend, where an
    // unmatched `/api/...` falls through to the SPA handler and returns 200.

    return (
        <>
            <a className="dq-skip-link" href="#inhalt">Zum Inhalt springen</a>
            <div className="header">
                {/* ⚠️ The header search bar was removed on the owner's instruction
                    (2026-09-05), and `/search` itself went at the cutover. It fed the previous
                    implementation's Whoosh index, broken in three ways documented in
                    CLAUDE.md — capped at ~10 results, never indexing the original German
                    title, and lost on every container redeploy. Search returns properly in v2,
                    from Postgres, with the eval set in `docs/EVAL-SET.md` already written. */}
                {/* ⚠️ `at-home` centred the header for the previous implementation's homepage.
                    `/` is the rebuild's landing page now, which is a left-aligned editorial
                    surface like every other, so the class is gone rather than applied to a
                    page it was never designed for. */}
                <h1>
                    <Link to="/"><span className="dq-sr-only">Democratiq — zur Startseite</span></Link>
                </h1>
                <Nav/>
                <BuyMeACoffee/>
            </div>
            <main id="inhalt" tabIndex={-1}>
                <Outlet/>
            </main>
            <Footer/>
            <CookieBanner/>
        </>
    )
}

